export enum bookingsListTypes {
    GET_BOOKINGS_LIST = '@@bookingsList/GET_BOOKINGS_LIST',
    GET_BOOKINGS_LIST_SUCCESS = '@@bookingsList/GET_BOOKINGS_LIST_SUCCESS',
    GET_BOOKINGS_LIST_FAIL = '@@bookingsList/GET_BOOKINGS_LIST_FAIL',

    GET_MILESTONESCONFIG_BK = '@BK/GET_MILESTONECONFIG',
    GET_MILESTONESCONFIG_BK_SUCCESS = '@BK/GET_MILESTONECONFIG_SUCCESS',
    GET_MILESTONESCONFIG_BK_FAIL = '@BK/GET_MILESTONECONFIG_FAIL',
}
